import React from 'react'
import PropTypes from 'prop-types'
import renderNode from './NodeRenderer'

function ListRenderer({ item, data, typeOfContent }) {
  function renderChildren() {
    return item.content.map((sentence, sentenceIndex) => {
      const indexLi = sentenceIndex
      const findlistItem = sentence.content.map(listItem => {
        if (listItem.nodeType === 'unordered-list' || listItem.nodeType === 'ordered-list') {
          return (
            <li key={indexLi} className="list-wrapper-item">
              <ListRenderer item={listItem} data={data} />
            </li>
          )
        }
        const phrase = renderNode({ typeOfContent, data: listItem.content })
        return (
          <li
            className={data.richTextTitle === 'Privacy Policy' ? 'legal__item' : ''}
            key={indexLi}
          >
            {phrase}
          </li>
        )
      })
      return findlistItem
    })
  }
  return item.nodeType === 'unordered-list' ? (
    <ul
      key={data.id}
      className={`${
        data.richTextTitle === 'Privacy Policy'
          ? 'legal__list legal__list--bullet'
          : 'rich-text-block rich-text-block__ul-list'
      }`}
    >
      {renderChildren()}
    </ul>
  ) : (
    <ol
      key={data.id}
      className={`${
        data.richTextTitle === 'Privacy Policy'
          ? 'legal__list legal__list--number'
          : 'rich-text-block rich-text-block__ol-list'
      }`}
    >
      {renderChildren()}
    </ol>
  )
}

ListRenderer.defaultProps = {
  typeOfContent: ''
}
ListRenderer.propTypes = {
  data: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  typeOfContent: PropTypes.string
}

export default ListRenderer
